/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { Icon, Theme, useTheme } from 'bold-ui'
import { useFlags } from 'config/useFlagsContext'
import { Fragment, useMemo } from 'react'

import { MChatRfPendingIcon } from './MChatRfPendingIcon'

interface MChatRfAccordionStepperProps {
  showCheckIcon: boolean
  showConnector: boolean
  showExclamationIcon: boolean
  showPendingIcon: boolean
}

export function MChatRfAccordionStepper(props: Readonly<MChatRfAccordionStepperProps>) {
  const { showCheckIcon, showConnector, showExclamationIcon, showPendingIcon } = props
  const { M_CHAT_RF_ENABLED } = useFlags()

  const theme = useTheme()
  const classes = useMemo(() => createStyles(theme), [theme])

  return (
    <div css={classes.root}>
      {showPendingIcon && <MChatRfPendingIcon />}

      {showCheckIcon && (
        <Fragment>
          <Icon icon='checkCircleFilled' fill='primary' size={1.5} />
          {showConnector && <span css={classes.connector} />}
        </Fragment>
      )}

      {showExclamationIcon &&
        (M_CHAT_RF_ENABLED ? (
          <Icon icon='exclamationTriangleFilled' fill='alert' />
        ) : (
          <Icon icon='infoCircleOutline' fill='info' />
        ))}
    </div>
  )
}

const createStyles = (theme: Theme) => ({
  root: css`
    margin-top: 0.375rem;
  `,
  connector: css`
    z-index: 1;
    height: calc(100% - 24px);
    position: absolute;
    top: 46px;
    left: 27px;
    border-left-width: 2px;
    border-left-style: solid;
    border-left-color: ${theme.pallete.gray.c80};
  `,
})
